import { createContext } from "react";

export const common = createContext(null);